import { EMPLOYEE_DETAILS_ACTIONS } from 'Actions/index';

const initialState = {
  name: '',
  designation: '',
  requestId: '',
  origin: {},
  destination: {},
  timeline: [],
  completed: false,
  trackingDevice: '',
  trackPath: [],
  movement: {},
  deliveryToWareHouse: false,
};

const {
  SET_EMPLOYEE_MOVE_DETAILS,
  SET_MOVE_TIMELINE,
  SET_MOVE_TRACK_PATH,
} = EMPLOYEE_DETAILS_ACTIONS;

const employeeMoveDetails = (state = initialState, action) => {
  switch (action.type) {
    case SET_EMPLOYEE_MOVE_DETAILS:
      return {
        ...initialState,
        name: action.payload.name,
        designation: action.payload.designation,
        ...action.payload.move,
      };
    case SET_MOVE_TIMELINE:
      return {
        ...state,
        timeline: action.payload,
      };
    case SET_MOVE_TRACK_PATH:
      return {
        ...state,
        trackPath: action.payload,
      };
    default:
      return state;
  }
};

export default employeeMoveDetails;
